import { atom } from "jotai";
import { atomWithToggle } from "@/utils";
import { MissionType } from "@/types";

const _atom = atom<MissionType | null>(null);

export const missionAtom = atom(
  (get) => get(_atom),
  (get, set, newMission: MissionType | null) => {
    set(_atom, newMission);
  },
);

export const missionSidebarSearchValueAtom = atom("");

export const missionSidebarSearchVisibilityAtom = atomWithToggle(false);
